/* eslint-disable no-case-declarations */
import axios from 'axios';
import { call, takeEvery } from 'redux-saga/effects';

import {
  ADD_TO_CART_SUCCESS,
  ADD_TO_CART_EVENTAPI,
  REMOVE_FROM_CART_SUCCESS,
} from '../constants';
import { logger } from '../../../../common/logger';

function* addToCartEventWorker(action) {
  try {
    const req = {};
    req['sp_product_id'] = action.datapack.product_id;
    req['sp_variant_id'] = action.datapack.variant_id;
    req['mr_offer_id'] = action.datapack.mrOfferID;
    if (action.type === ADD_TO_CART_SUCCESS) {
      req['quantity'] = +1;
    } else {
      req['quantity'] = -1;
    }

    const httpArgs = [ADD_TO_CART_EVENTAPI, req];
    const { data } = yield call(axios.post, ...httpArgs);
  } catch (e) {
    logger.log(e);
  }
}

export default function* addToCartEventWatcher() {
  yield takeEvery(
    [ADD_TO_CART_SUCCESS, REMOVE_FROM_CART_SUCCESS],
    addToCartEventWorker,
  );
}
